import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
export class RevampDeviceBoxAdapter {
    type = "audio-effect";
    accepts = "audio";
    #context;
    #box;
    #parametric;
    namedParameter; // let typescript infer the type
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#parametric = new ParameterAdapterSet(this.#context);
        this.namedParameter = this.#wrapParameters(box);
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get indexField() { return this.#box.index; }
    get labelField() { return this.#box.label; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get host() { return this.#box.host; }
    get spectrum() { return this.#box.address.append(0xFFF); }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { this.#parametric.terminate(); }
    #wrapParameters(box) {
        return {
            highPass: createPass(this.#parametric, box.highPass, "High-Pass"),
            lowShelf: createShelf(this.#parametric, box.lowShelf, "Low-Shelf"),
            lowBell: createBell(this.#parametric, box.lowBell, "Low-Bell"),
            midBell: createBell(this.#parametric, box.midBell, "Mid-Bell"),
            highBell: createBell(this.#parametric, box.highBell, "High-Bell"),
            highShelf: createShelf(this.#parametric, box.highShelf, "High-Shelf"),
            lowPass: createPass(this.#parametric, box.lowPass, "Low-Pass")
        };
    }
}
const FrequencyMapping = ValueMapping.exponential(20.0, 20_000.0);
const GainMapping = ValueMapping.linear(-24.0, 24.0);
const QMapping = ValueMapping.exponential(0.01, 10.0);
const createPass = (parametric, pass, name) => {
    return ({
        enabled: parametric.createParameter(pass.enabled, ValueMapping.bool, StringMapping.bool, "enabled"),
        frequency: parametric.createParameter(pass.frequency, FrequencyMapping, StringMapping.numeric({ unit: "Hz", fractionDigits: 0 }), `${name} Freq`),
        order: parametric.createParameter(pass.order, ValueMapping.linearInteger(0, 3), StringMapping.indices("db", ["12", "24", "36", "48"]), `${name} Order`),
        q: parametric.createParameter(pass.q, QMapping, StringMapping.numeric({ fractionDigits: 3 }), `${name} Q`)
    });
};
const createShelf = (parametric, shelf, name) => ({
    enabled: parametric.createParameter(shelf.enabled, ValueMapping.bool, StringMapping.bool, "enabled"),
    frequency: parametric.createParameter(shelf.frequency, FrequencyMapping, StringMapping.numeric({ unit: "Hz", fractionDigits: 0 }), `${name} Freq`),
    gain: parametric.createParameter(shelf.gain, GainMapping, StringMapping.numeric({ unit: "db", fractionDigits: 1, bipolar: true }), `${name} Gain`, 0.5)
});
const createBell = (parametric, bell, name) => ({
    enabled: parametric.createParameter(bell.enabled, ValueMapping.bool, StringMapping.bool, "enabled"),
    frequency: parametric.createParameter(bell.frequency, FrequencyMapping, StringMapping.numeric({ unit: "Hz", fractionDigits: 0 }), `${name} Freq`),
    gain: parametric.createParameter(bell.gain, GainMapping, StringMapping.numeric({ unit: "db", fractionDigits: 1, bipolar: true }), `${name} Gain`, 0.5),
    q: parametric.createParameter(bell.q, QMapping, StringMapping.numeric({ fractionDigits: 3 }), `${name} Q`)
});
